import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useSelector } from "react-redux";

import "./App.css";
import Home from "./Pages/HomePage/Home";
import { Routes, Route, Navigate } from "react-router-dom";
import Header from "./Layout/Header/Header";
import Footer from "./Layout/Footer/Footer";
import NftDetail from "./Pages/NftDetail/NftDetail";
import Explore from "./Pages/Explore/Explore";
import SearchPage from "./Pages/Explore/SearchPage";
import Create from "./Pages/Create/Create";
import Profile from "./Pages/Profile/Profile";
import Settings from "./Pages/Settings/Settings";
import MetaConnect from "./Components/MetaConnect/MetaConnect";
import ScrollToTop from "./Components/ScrollToTop";

function App() {
  const { address } = useSelector((state) => state.wallet);

  console.log(address);
  return (
    <div className="App">
      <ToastContainer />
      <Header />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route element={<NftDetail />} path="/NftDetail/:id" />
        <Route path="/Explore" element={<Explore />} />
        <Route path="/Explore/:lat/:lng" element={<SearchPage />} />
        <Route path="/Connect" element={<MetaConnect />} />
        {/* <Route path="/nftPage" element={<NFTPage />} />
        <Route path="/profile" element={<Profile />} />
      <Route path="/sellNFT" element={<SellNFT />} /> */}
        {address && (
          <>
            <Route path="/Create" element={<Create />} />
            <Route path="/Profile" element={<Profile />} />
            <Route path="/Settings/:walletAddress" element={<Settings />} />
          </>
        )}
        <Route path="*" element={<Navigate to="/Connect" />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
